export const StatusIndicator = () => {
  return (
    <div className="fixed bottom-5 right-5 glass-strong px-4 py-2.5 rounded-full text-xs text-muted-foreground flex items-center gap-2 z-50">
      <div className="w-2 h-2 bg-success rounded-full animate-pulse-glow" />
      Sessão ativa • Dados sincronizados
    </div>
  );
};
